import { Typography } from 'components/Typography/Typography'

interface PriceSectionProps {
  tokenXSymbol: string
  tokenYSymbol: string
  currentPrice?: string
}

export const PriceSection = ({ currentPrice, tokenXSymbol, tokenYSymbol }: PriceSectionProps) => {
  return (
    <Typography variant="caption" color="secondary">
      {`1 ${tokenXSymbol} ≈ ${currentPrice} ${tokenYSymbol}`}
    </Typography>
  )
}
